import styled from 'styled-components'

interface ISpendTrackerStyledProps {}

export const SpendTrackerStyled = styled.div<ISpendTrackerStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
